import { render, staticRenderFns } from "./Refunds.vue?vue&type=template&id=eb3bdec2&scoped=true"
import script from "./Refunds.vue?vue&type=script&lang=js"
export * from "./Refunds.vue?vue&type=script&lang=js"
import style0 from "./Refunds.vue?vue&type=style&index=0&id=eb3bdec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3bdec2",
  null
  
)

export default component.exports